import {Parent} from 'app/types/appBar/Parent';
import {ParentEntity} from 'app/types/appBar/ParentEntity';

export class DistrictUnsetParentFactory {
  static create(): Parent {
    return {
      entity: ParentEntity.Region,
      name: 'Keine Region gewählt',
      slugs: null,
    };
  }
}
